import { AnimatePresence, motion } from "framer-motion";
import { NavLink } from "react-router-dom";

import { useAppHeaderHeight } from "@/hooks";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { LanguageSwitcher } from "@/components/languageSwitcher";
import { CALENDLY_URL } from "@/constants";
import { langPath, useLang, useTranslation } from "@/i18n";

interface Link {
  name: string;
  path: string;
}

interface HeaderProps {
  className?: string;
  links: Link[];
}

export const Header: React.FC<HeaderProps> = ({
  className,
}) => {
  const { headerRef } = useAppHeaderHeight();
  const lang = useLang();
  const t = useTranslation();

  return (
    <AnimatePresence>
      <motion.div
        ref={headerRef}
        className={cn(
          "fixed top-0 flex w-full flex-col space-y-2 bg-background-primary pb-2 pt-safe-or-2 h-[75px] bg-[#1d2128]",
          className,
        )}
        style={{ zIndex: 101 }}
      >
        <div className="flex flex-1 flex-row items-center px-6">
          <NavLink to={langPath("/", lang)} className="no-focus cursor-pointer">
            <Logo />
          </NavLink>

          <div className="flex flex-1 flex-row items-center justify-end space-x-3">
            <LanguageSwitcher />
            <div>
              <a href={CALENDLY_URL} className="w-full inline-block" rel={"noreferrer"} target={"_blank"}>
                <Button shape="circle" className="text-xs bg-[#01C6FB] text-[#10141a] font-semibold border-0">
                  {t.header.cta}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

const Logo: React.FC = () => (
  <div className="flex flex-row items-center space-x-3">
    <span className="text-md font-semibold text-[#01C6FB]">
      <img src="/images/rckntvlogo.png" alt="Rocknitive Logo" className="w-8 inline-block mr-2" />
      Rocknitive
    </span>
  </div>
);
